'use client';

import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { VStack } from '@terra/ui-styled-system';
import { Dialog } from '../../../components/dialog';
import { InternalNetworkEnrollmentSecretsPanel } from './InternalNetworkEnrollmentSecretsPanel';
import type { InternalNetworkSecretsDialogState } from './useInternalNetworkSensorEnrollmentActions';

export type InternalNetworkEnrollmentSecretsDialogProps = {
  dialog: InternalNetworkSecretsDialogState | null;
  onClose: () => void;
  connectionProgress?: ReactNode;
};

export function InternalNetworkEnrollmentSecretsDialog({
  dialog,
  onClose,
  connectionProgress,
}: InternalNetworkEnrollmentSecretsDialogProps) {
  const t = useTranslations('designSystem.networkSettings.internalConnection');
  const tCommon = useTranslations('designSystem.common');

  return (
    <Dialog
      open={dialog !== null}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
      size="lg"
      title={dialog?.title ?? ''}
      description={t('enrollments.apiKeyWarning')}
      closeLabel={tCommon('close')}
      primaryAction={{ label: t('done'), onClick: onClose }}
      dataTestid="internal-network-enrollment-secrets-dialog"
      closeDataTestid="internal-network-enrollment-done"
      lazyMount
      unmountOnExit
    >
      <VStack alignItems="stretch" gap={6} w="full">
        {connectionProgress}
        {dialog ? (
          <InternalNetworkEnrollmentSecretsPanel
            secrets={dialog.secrets}
            maxHeight="min(55vh, 480px)"
          />
        ) : null}
      </VStack>
    </Dialog>
  );
}
